/**
 * Comformidable Custom Cart Drawer
 * Vervangt Qikify volledig.
 * Features: AJAX cart, reward tiers, upsell via recommendations API,
 *           kortingscode, dynamische levertijd per markt, feestdagen
 */

(function () {
  'use strict';

  // ─── Config (ingesteld vanuit Liquid) ────────────────────────────────────
  const CONFIG = window.cfCartConfig || {};
  const i18n    = CONFIG.i18n || {};
  const ROOT   = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const DELIVERY_CONFIG = CONFIG.delivery || {};
  const REWARD_TIERS    = CONFIG.rewardTiers || [
    { minItems: 2, discount: 10, code: 'STAF10' },
    { minItems: 3, discount: 15, code: 'STAF15' },
    { minItems: 5, discount: 25, code: 'STAF25' }
  ];

  // ─── State ───────────────────────────────────────────────────────────────
  let _cart          = null;
  let _upsellLoaded  = false;
  let _qtyDebounce   = {};
  let _toastTimer    = null;

  // ─── DOM refs ────────────────────────────────────────────────────────────
  const $ = (id) => document.getElementById(id);
  const drawer        = document.getElementById('cf-cart-drawer');
  const overlay       = document.getElementById('cf-cart-overlay');

  // ─── Utilities ───────────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) cents = 0;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const locale   = document.documentElement.lang || 'nl-NL';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  // Verwijdert letterlijke <strong> uit ge-escapete locale strings en zet ze om naar echte tags
  function unescapeStrong(str) {
    if (!str) return str;
    return str
      .replace(/&lt;strong&gt;/g, '<strong>')
      .replace(/&lt;\/strong&gt;/g, '</strong>')
      .replace(/&lt;br&gt;/g, '<br>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');
  }

  function showToast(msg, duration = 2800) {
    let el = document.querySelector('.cf-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cf-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('cf-toast--show');
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(() => el.classList.remove('cf-toast--show'), duration);
  }

  // ─── DELIVERY LOGIC ──────────────────────────────────────────────────────

  /**
   * Bepaal de verwachte leverdatum op basis van:
   * - Huidig tijdstip (Amsterdam timezone)
   * - Markt (NL/BE = cut-off 23u, rest = 10u)
   * - Feestdagen / gesloten dagen
   * - Verzendtijden per markt
   */
  function getDeliveryText() {
    const now = new Date();

    // Amsterdam tijd
    const amsTZ   = 'Europe/Amsterdam';
    const amsNow  = new Date(now.toLocaleString('en-US', { timeZone: amsTZ }));
    const hour    = amsNow.getHours();
    const minute  = amsNow.getMinutes();

    const market  = (CONFIG.market || '').toLowerCase();
    const isNLBE  = market === 'nl' || market === 'be' || market === 'belgie' || market === '' || !market; // NL + BE = volgende werkdag

    const cutoff  = isNLBE ? DELIVERY_CONFIG.cutoffNLBE || 23 : DELIVERY_CONFIG.cutoffOther || 10;
    const holidays = (DELIVERY_CONFIG.holidays || []).concat(DELIVERY_CONFIG.extraClosedDays || []);

    // Controleer of vandaag een feestdag is
    function isHoliday(date) {
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const yyyy = date.getFullYear();
      const ymd  = `${yyyy}-${mm}-${dd}`;
      const mmd  = `${mm}-${dd}`;
      return holidays.includes(ymd) || holidays.includes(mmd);
    }

    // Volgende werkdag (maandag t/m vrijdag, geen feestdag)
    function nextWorkday(from, skipToday = false) {
      const d = new Date(from);
      if (skipToday) d.setDate(d.getDate() + 1);
      while (true) {
        const dow = d.getDay(); // 0=zo, 6=za
        if (dow !== 0 && dow !== 6 && !isHoliday(d)) return d;
        d.setDate(d.getDate() + 1);
      }
    }

    // Voeg N werkdagen toe
    function addWorkdays(from, n) {
      let d = new Date(from);
      let added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6 && !isHoliday(d)) added++;
      }
      return d;
    }

    // Dagformat
    const dayNames = {
      'nl': ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'],
      'de': ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
      'fr': ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],
      'da': ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'],
      'en': ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    };
    const locale = (CONFIG.locale || 'nl').toLowerCase().substring(0, 2);
    const days   = dayNames[locale] || dayNames['nl'];

    function formatDate(d) {
      const dow = days[d.getDay()];
      const dd  = d.getDate();
      const monthNames = {
        'nl': ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'],
        'de': ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
        'fr': ['jan','fév','mar','avr','mai','jun','jul','aoû','sep','oct','nov','déc'],
        'da': ['jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec'],
        'en': ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      };
      const months = monthNames[locale] || monthNames['nl'];
      return `${dow} ${dd} ${months[d.getMonth()]}`;
    }

    const beforeCutoff = hour < cutoff || (hour === cutoff && minute === 0);
    const todayIsWorkday = amsNow.getDay() !== 0 && amsNow.getDay() !== 6 && !isHoliday(amsNow);

    let deliveryDate;
    let prefix;

    if (isNLBE) {
      // NL/BE: voor 23:00 op werkdag = morgen
      if (beforeCutoff && todayIsWorkday) {
        deliveryDate = nextWorkday(amsNow, true);
      } else {
        // Na cutoff of weekend: volgende werkdag daarna
        const nextDay = nextWorkday(amsNow, !todayIsWorkday || !beforeCutoff);
        deliveryDate  = nextWorkday(nextDay, true);
      }

      // Check of vandaag/gisteren van toepassing is
      const tomorrow = new Date(amsNow);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const isTomorrow = deliveryDate.getDate() === tomorrow.getDate() &&
                         deliveryDate.getMonth() === tomorrow.getMonth();

      if (beforeCutoff && todayIsWorkday) {
        prefix = `Voor ${cutoff}:00 besteld = `;
        if (isTomorrow) {
          prefix += 'morgen in huis';
          deliveryDate = null;
        }
      } else {
        prefix = 'Besteld = ';
      }
    } else {
      // Internationaal: 1-4 werkdagen (toon 2 werkdagen als verwacht, 4 als uiterlijk)
      const dispatchDay  = beforeCutoff && todayIsWorkday
        ? amsNow
        : nextWorkday(amsNow, true);

      // 2-4 werkdagen voor alle internationale markten
      deliveryDate = addWorkdays(dispatchDay, 2);
      const latestDate = addWorkdays(dispatchDay, 4);

      const deliveryLabels = {
        'nl': `Verwacht ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'de': `Voraussichtlich ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'fr': `Livraison prévue ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'da': `Forventet ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'en': `Expected ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`
      };
      return deliveryLabels[locale] || deliveryLabels['nl'];
    }

    if (deliveryDate === null) {
      return prefix;
    }
    return prefix + formatDate(deliveryDate);
  }

  function renderDelivery() {
    const el = $('cf-delivery-text');
    if (el) el.textContent = getDeliveryText();
  }

  // ─── REWARD TIER BAR ─────────────────────────────────────────────────────

  function renderRewardBar(itemCount) {
    const msgEl  = $('cf-reward-message');
    const barEl  = $('cf-reward-bar-fill');
    const section = $('cf-reward-section');
    if (!msgEl || !barEl) return;

    // Bepaal huidige en volgende tier
    let currentTier = null;
    let nextTier    = null;

    for (const tier of REWARD_TIERS) {
      if (itemCount >= tier.minItems) {
        currentTier = tier;
      } else if (!nextTier) {
        nextTier = tier;
      }
    }

    const maxItems  = REWARD_TIERS[REWARD_TIERS.length - 1].minItems;
    const fillPct   = Math.min((itemCount / maxItems) * 100, 100);
    barEl.style.width = fillPct + '%';

    // Markers actief maken
    document.querySelectorAll('.cf-reward__tier-marker').forEach((marker, i) => {
      const tier = REWARD_TIERS[i];
      marker.classList.toggle('cf-tier--active', tier && itemCount >= tier.minItems);
    });

    if (currentTier && !nextTier) {
      const unlockedMsg = unescapeStrong(i18n.rewardUnlocked || 'Je hebt {{discount}} korting ontgesloten!')
        .replace('{{discount}}', currentTier.discount + '%');
      msgEl.innerHTML = '🎉 ' + unlockedMsg;
      msgEl.classList.add('cf-reward--unlocked');
    } else if (nextTier) {
      const needed  = nextTier.minItems - itemCount;
      const artWord = needed === 1 ? (i18n.rewardArticle || 'artikel') : (i18n.rewardArticles || 'artikelen');
      const addText = i18n.rewardAdd || 'Voeg nog';
      const forText = i18n.rewardFor || 'toe voor';
      const discText = i18n.rewardDiscount || 'korting';
      msgEl.innerHTML = `${addText} <strong>${needed} ${artWord}</strong> ${forText} <strong>${nextTier.discount}% ${discText}</strong>!`;
      msgEl.classList.remove('cf-reward--unlocked');
    } else {
      msgEl.innerHTML = i18n.rewardAdd || 'Voeg artikelen toe voor staffelkorting!';
      msgEl.classList.remove('cf-reward--unlocked');
    }
  }


  // ─── FREE SHIPPING BAR ───────────────────────────────────────────────────

  function getShippingThreshold() {
    const country   = (CONFIG.market || 'NL').toUpperCase();
    const thresholds = (CONFIG.shipping && CONFIG.shipping.thresholds) || {};
    return thresholds[country] || thresholds['default'] || 3000;
  }

  function renderShippingBar(cart) {
    const barEl     = $('cf-shipping-bar');
    const msgEl     = $('cf-shipping-message');
    const fillEl    = $('cf-shipping-fill');
    if (!barEl || !msgEl || !fillEl) return;

    if (!cart || cart.item_count === 0) {
      barEl.style.display = 'none';
      return;
    }

    const threshold = getShippingThreshold();
    const total     = cart.total_price || 0;
    const remaining = Math.max(0, threshold - total);
    const pct       = Math.min(100, (total / threshold) * 100);

    barEl.style.display = 'block';
    fillEl.style.width  = pct + '%';

    if (remaining <= 0) {
      msgEl.innerHTML = unescapeStrong(i18n.shippingUnlocked || '🎉 Gratis verzending!');
      fillEl.classList.add('cf-shipping--unlocked');
    } else {
      fillEl.classList.remove('cf-shipping--unlocked');
      const amountFormatted = formatMoney(remaining);
      const msg = unescapeStrong(i18n.shippingRemaining || 'Nog <strong>{{amount}}</strong> tot gratis verzending!')
        .replace('{{amount}}', amountFormatted);
      msgEl.innerHTML = msg;
    }
  }

  // ─── COUNTDOWN TIMER ─────────────────────────────────────────────────────

  let _countdownInterval = null;

  function startCountdown() {
    const countdownEl = $('cf-delivery-countdown');
    const timeEl      = $('cf-countdown-time');
    if (!countdownEl || !timeEl) return;

    const amsTZ   = 'Europe/Amsterdam';
    const market  = (CONFIG.market || '').toLowerCase();
    const isNLBE  = market === 'nl' || market === 'be' || market === 'belgie' || market === '' || !market; // NL + BE = volgende werkdag
    const cutoff  = isNLBE
      ? (DELIVERY_CONFIG.cutoffNLBE || 23)
      : (DELIVERY_CONFIG.cutoffOther || 22);

    function tick() {
      const now    = new Date();
      const amsNow = new Date(now.toLocaleString('en-US', { timeZone: amsTZ }));
      const hour   = amsNow.getHours();
      const min    = amsNow.getMinutes();
      const sec    = amsNow.getSeconds();
      const dow    = amsNow.getDay(); // 0=zo, 6=za

      // Alleen tonen op werkdagen vóór cutoff
      const isWorkday   = dow >= 1 && dow <= 5;
      const beforeCutoff = hour < cutoff;

      if (!isWorkday || !beforeCutoff) {
        countdownEl.style.display = 'none';
        return;
      }

      // Bereken resterende tijd tot cutoff
      const totalSecsLeft = (cutoff - hour - 1) * 3600 + (59 - min) * 60 + (59 - sec);
      if (totalSecsLeft <= 0) {
        countdownEl.style.display = 'none';
        return;
      }

      const hLeft = Math.floor(totalSecsLeft / 3600);
      const mLeft = Math.floor((totalSecsLeft % 3600) / 60);
      const sLeft = totalSecsLeft % 60;

      const timeStr = hLeft > 0
        ? `${hLeft}u ${String(mLeft).padStart(2,'0')}m`
        : `${mLeft}m ${String(sLeft).padStart(2,'0')}s`;

      const label = (i18n.countdownLabel || 'nog {{time}}').replace('{{time}}', timeStr);
      timeEl.textContent = label;
      countdownEl.style.display = 'inline';
    }

    clearInterval(_countdownInterval);
    tick();
    _countdownInterval = setInterval(tick, 1000);
  }

  function stopCountdown() {
    clearInterval(_countdownInterval);
    const countdownEl = $('cf-delivery-countdown');
    if (countdownEl) countdownEl.style.display = 'none';
  }


  // ─── DREMPEL MELDING ─────────────────────────────────────────────────────
  // Detecteert of staffelkorting de klant onder de gratis verzending drempel duwt
  // En suggereert het volgende tier als dat hen verder helpt

  function renderThresholdWarning(cart) {
    const warningEl = $('cf-threshold-warning');
    const msgEl     = $('cf-threshold-message');
    if (!warningEl || !msgEl) return;

    const itemCount   = cart.item_count || 0;
    const subtotal    = cart.total_price || 0; // prijs NA korting
    const threshold   = getShippingThreshold();

    // Bepaal huidige actieve tier op basis van item count
    let activeTier = null;
    for (const tier of REWARD_TIERS) {
      if (itemCount >= tier.minItems) activeTier = tier;
    }

    // Geen korting actief of al boven drempel → geen melding
    if (!activeTier || subtotal >= threshold) {
      warningEl.style.display = 'none';
      return;
    }

    // Klant heeft korting maar zakt onder gratis verzending drempel
    const needed = threshold - subtotal;

    // Kijk of er een volgend tier is dat de klant nog meer voordeel geeft
    const nextTier = REWARD_TIERS.find(t => t.minItems > itemCount);

    let msg = '';

    if (nextTier) {
      // Suggestie: voeg X toe voor volgend tier + gratis verzending
      // Bereken hoeveel extra nodig is om boven drempel te komen bij volgend tier
      // Benadering: huidige prijs per item als gemiddelde
      const avgItemPrice = cart.items.length > 0
        ? cart.items.reduce((sum, i) => sum + i.original_price, 0) / cart.items.length
        : 0;

      // Met het volgende tier percentage: hoeveel moet subtotaal zijn voor gratis verzending?
      const neededForNextTier = Math.ceil(threshold / (1 - nextTier.discount / 100));
      const currentOriginalTotal = cart.items.reduce((sum, i) => sum + i.original_line_price, 0);
      const extraNeeded = Math.max(0, neededForNextTier - currentOriginalTotal);

      if (extraNeeded > 0 && extraNeeded < threshold) {
        // Suggestie: voeg toe voor volgend tier én gratis verzending
        msg = unescapeStrong(i18n.thresholdSuggestion || '💡 Voeg nog <strong>{{amount}}</strong> toe voor {{discount}}% korting én gratis verzending.')
          .replace('{{amount}}', formatMoney(extraNeeded))
          .replace('{{discount}}', nextTier.discount);
      } else {
        // Gewone waarschuwing
        msg = unescapeStrong(i18n.thresholdWarning || '⚠️ Met je staffelkorting zakt je totaal onder €{{threshold}}. Voeg nog <strong>{{amount}}</strong> toe voor gratis verzending.')
          .replace('{{threshold}}', (threshold / 100).toFixed(0))
          .replace('{{amount}}', formatMoney(needed));
      }
    } else {
      // Al op hoogste tier — gewone waarschuwing
      msg = unescapeStrong(i18n.thresholdWarning || '⚠️ Met je staffelkorting zakt je totaal onder €{{threshold}}. Voeg nog <strong>{{amount}}</strong> toe voor gratis verzending.')
        .replace('{{threshold}}', (threshold / 100).toFixed(0))
        .replace('{{amount}}', formatMoney(needed));
    }

    msgEl.innerHTML = msg;
    warningEl.style.display = 'block';
  }

  // ─── CART API ─────────────────────────────────────────────────────────────

  async function fetchCart() {
    const res  = await fetch(`${ROOT}cart.js?t=${Date.now()}`, {
      headers: { 'Accept': 'application/json' }
    });
    const cart = await res.json();
    _cart = cart;
    return cart;
  }

  async function addToCart(variantId, quantity = 1, properties = {}) {
    const res = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity, properties }] })
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Kon product niet toevoegen');
    }
    return res.json();
  }

  async function changeCartItem(key, quantity) {
    const res = await fetch(`${ROOT}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) {
      const fout = new Error('cart change ' + res.status);
      fout.stockFout = res.status === 422;
      throw fout;
    }
    return res.json();
  }

  async function applyDiscount(code) {
    const res = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    return res.json();
  }

  // ─── CART RENDER ─────────────────────────────────────────────────────────

  function renderCart(cart) {
    const itemsEl   = $('cf-cart-items');
    const emptyEl   = $('cf-cart-empty');
    const footerEl  = $('cf-cart-footer');
    const rewardEl  = $('cf-reward-section');
    const countEl   = $('cf-cart-count');

    if (!itemsEl) return;

    const itemCount = cart.item_count || 0;
    if (countEl) countEl.textContent = itemCount;

    // Update alle cart badges op de pagina
    document.querySelectorAll('[data-cart-count], .cart-count, .cf-badge, #cfm-cart-count').forEach(el => {
      el.textContent = itemCount;
    });

    if (itemCount === 0) {
      itemsEl.innerHTML = '';
      var leegCadeau = document.getElementById('cfKitCadeau');
      if (leegCadeau) { leegCadeau.hidden = true; leegCadeau.innerHTML = ''; }
      if (emptyEl) emptyEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      if (rewardEl) rewardEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (rewardEl) rewardEl.style.display = 'block';

    // Render items
    itemsEl.innerHTML = cart.items.map(item => {
      const imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace('.jpg', '_120x120.jpg').replace('.png', '_120x120.png')
        : '';
      const variantInfo = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cf-cart-item__variant">${item.variant_title}</div>` : '';
      // Laat zien dat een regel een abonnement is, anders ziet de klant alleen
      // een lagere prijs zonder te weten waarom.
      const aboInfo = item.selling_plan_allocation
        ? `<div class="cf-cart-item__abo">↻ ${item.selling_plan_allocation.selling_plan.name}</div>` : '';
      return `
        <div class="cf-cart-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
          <img class="cf-cart-item__image" src="${imgSrc || 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'72\' height=\'72\'%3E%3Crect fill=\'%23f3f4f6\' width=\'72\' height=\'72\'/%3E%3C/svg%3E'}"
               alt="${item.product_title}" loading="lazy" width="72" height="72">
          <div class="cf-cart-item__info">
            <div class="cf-cart-item__title">${item.product_title}</div>
            ${variantInfo}
            ${aboInfo}
            <div class="cf-cart-item__bottom">
              <div class="cf-qty-control">
                <button class="cf-qty-btn cf-qty-minus" data-key="${item.key}" aria-label="Minder" ${item.quantity <= 1 ? '' : ''}>−</button>
                <span class="cf-qty-display">${item.quantity}</span>
                <button class="cf-qty-btn cf-qty-plus" data-key="${item.key}" aria-label="Meer">+</button>
              </div>
              <div class="cf-cart-item__price-col">
                <span class="cf-cart-item__price">${formatMoney(item.final_line_price)}</span>
                <button class="cf-cart-item__remove" data-key="${item.key}" aria-label="Verwijder ${item.product_title}">×</button>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');

    // Reward bar
    renderRewardBar(itemCount);
    renderKitCadeau(cart, itemsEl);

    // Gratis verzending bar
    renderShippingBar(cart);

    // Drempel melding
    renderThresholdWarning(cart);

    // Totalen
    renderTotals(cart);

    // Kortingscodes
    renderDiscountCodes(cart);

    // Upsell laden (eenmalig of bij wijziging eerste product)
    loadUpsell(cart);
  }

  function renderTotals(cart) {
    const totalEl    = $('cf-total-price');
    const discountRow = $('cf-discount-row');
    const discountAmt = $('cf-discount-amount');
    const discountLbl = $('cf-discount-label');

    if (totalEl) totalEl.innerHTML = `<strong>${formatMoney(cart.total_price)}</strong>`;

    // Automatische kortingen
    const autoDiscounts = cart.cart_level_discount_applications || [];
    if (autoDiscounts.length > 0 && discountRow) {
      const totalDiscount = autoDiscounts.reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0);
      discountRow.style.display = 'flex';
      if (discountAmt) discountAmt.textContent = `−${formatMoney(totalDiscount)}`;
      if (discountLbl) discountLbl.textContent = autoDiscounts.map(d => d.title).join(', ');
    } else if (discountRow) {
      discountRow.style.display = 'none';
    }
  }

  function renderDiscountCodes(cart) {
    const activeCodesEl = $('cf-discount-active-codes');
    if (!activeCodesEl) return;

    const codes = cart.discount_codes || [];
    activeCodesEl.innerHTML = codes
      .filter(dc => dc.applicable)
      .map(dc => `
        <span class="cf-discount__active-tag">
          ✓ ${dc.code}
          <button class="cf-discount__remove-code" data-code="${dc.code}" aria-label="Verwijder kortingscode ${dc.code}">×</button>
        </span>
      `).join('');
  }

  // ─── UPSELL via Shopify Recommendations API ───────────────────────────────

  async function loadUpsell(cart) {
    const upsellEl  = $('cf-cart-upsell');
    const sliderEl  = $('cf-upsell-slider');
    if (!upsellEl || !sliderEl || cart.items.length === 0) return;

    // ── Regel-gebaseerde cross-sells (kloppende paren per productgroep) ──
    // De anti-snurkkit (goedkoop) komt als eerste suggestie wanneer de cart
    // nog onder de gratis-verzenddrempel zit: kleine toevoeging, gratis verzending.
    const RULES = [
      { re: /neusdouche/i,                s: ['comformidable-nasaal-spoelzout-50-stuks'] },
      { re: /spoelzout/i,                 s: ['neusdouche-90-zakjes-spoelzout'] },
      { re: /magnetisch/i,                s: ['magnetische-neusstrips-refill-100'] },
      { re: /neusstrip|neuspleister/i,    s: ['mondtape-30-stuks'] },
      { re: /mondtape/i,                  s: ['anti-snurk-neusstrips-100-stuks'] },
      { re: /hydra lift/i,                s: ['comformidable-collagen-calm-balance-mask-purifying-calming-4-stuks', 'comformidable-collagen-glow-boost-mask-brightening-radiance-4-stuks'] },
      { re: /calm balance/i,              s: ['comformidable®-collagen-hydra-lift-mask-deep-hydration-firming-4-stuks', 'comformidable-collagen-glow-boost-mask-brightening-radiance-4-stuks'] },
      { re: /glow boost/i,                s: ['comformidable®-collagen-hydra-lift-mask-deep-hydration-firming-4-stuks', 'comformidable-collagen-calm-balance-mask-purifying-calming-4-stuks'] },
      { re: /slaappleister|sleep patch/i, s: ['mondtape-30-stuks'] }
    ];
    const FILLER = 'anti-snurk-kit-compleet';

    const cartProductIds = cart.items.map(i => i.product_id);
    const cartHandles    = cart.items.map(i => i.handle);

    const wanted = [];
    let drempel = 3000;
    try { drempel = getShippingThreshold(); } catch (e) {}
    if (cart.total_price < drempel && !cartHandles.includes(FILLER)) wanted.push(FILLER);
    for (const item of cart.items) {
      for (const rule of RULES) {
        if (rule.re.test(item.title || '')) {
          for (const h of rule.s) {
            if (!cartHandles.includes(h) && !wanted.includes(h)) wanted.push(h);
          }
        }
      }
    }

    try {
      // 1) regel-producten ophalen (alleen leverbaar tonen)
      const ruleProducts = [];
      for (const h of wanted.slice(0, 4)) {
        try {
          const r = await fetch(`${ROOT}products/${encodeURIComponent(h)}.js`);
          if (r.ok) {
            const p = await r.json();
            if (p.variants && p.variants[0] && p.variants[0].available) ruleProducts.push(p);
          }
        } catch (e) {}
      }

      // 2) aanvullen met Shopify-aanbevelingen
      const firstProductId = cart.items[0].product_id;
      let recs = [];
      try {
        const res  = await fetch(`${ROOT}recommendations/products.json?product_id=${firstProductId}&limit=8&intent=related`);
        const data = await res.json();
        recs = (data.products || []);
      } catch (e) {}

      const seen = new Set(cartProductIds.concat(ruleProducts.map(p => p.id)));
      const extra = recs.filter(p => !seen.has(p.id) && p.variants && p.variants[0] && p.variants[0].available);
      const producten = ruleProducts.concat(extra).slice(0, 5);

      if (producten.length === 0) {
        upsellEl.style.display = 'none';
        return;
      }

      upsellEl.style.display = 'block';
      sliderEl.innerHTML = producten.map(product => {
        const variant  = product.variants && product.variants[0];
        const imgSrc   = product.featured_image || '';
        const price    = variant ? formatMoney(variant.price) : '';
        const soldOut  = variant && !variant.available;
        return `
          <div class="cf-upsell-card">
            <img class="cf-upsell-card__image" src="${imgSrc}" alt="${product.title}" loading="lazy">
            <div class="cf-upsell-card__body">
              <div class="cf-upsell-card__title">${product.title}</div>
              <div class="cf-upsell-card__price">${price}</div>
              <button class="cf-upsell-card__add"
                      data-variant-id="${variant ? variant.id : ''}"
                      ${soldOut ? 'disabled' : ''}>
                ${soldOut ? (i18n.soldOut || 'Uitverkocht') : (i18n.addToCart || 'Toevoegen')}
              </button>
            </div>
          </div>`;
      }).join('');

    } catch (e) {
      console.warn('[CF Cart] Upsell laden mislukt:', e);
      upsellEl.style.display = 'none';
    }
  }

  // ─── DRAWER OPEN / CLOSE ─────────────────────────────────────────────────

  async function openDrawer() {
    if (!drawer) return;
    renderDelivery();
    startCountdown();
    const cart = await fetchCart();
    renderCart(cart);
    drawer.classList.add('cf-is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (overlay) overlay.classList.add('cf-is-open');
    document.body.style.overflow = 'hidden';
    // Focus management
    const closeBtn = $('cf-cart-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('cf-is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (overlay) overlay.classList.remove('cf-is-open');
    document.body.style.overflow = '';
    stopCountdown();
  }

  // ─── EVENT LISTENERS ─────────────────────────────────────────────────────

  function initEvents() {
    // Sluit knop
    const closeBtn = $('cf-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Overlay klik
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // ESC toets
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('cf-is-open')) {
        closeDrawer();
      }
    });

    // Doorgaan winkelen (lege cart)
    const continueBtn = $('cf-continue-shopping');
    if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

    // Cart icon / cart knop openen — ondersteunt Minimog's eigen trigger
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-open-cart], .js-open-cart, [href="/cart"]');
      if (trigger && !trigger.closest('#cf-cart-drawer')) {
        e.preventDefault();
        openDrawer();
      }
    });

    // Quantity +/- en verwijder (event delegation op items container)
    const itemsEl = $('cf-cart-items');
    if (itemsEl) {
      itemsEl.addEventListener('click', handleItemAction);
    }

    // Upsell toevoegen
    const upsellEl = $('cf-cart-upsell');
    if (upsellEl) {
      upsellEl.addEventListener('click', async (e) => {
        const btn = e.target.closest('.cf-upsell-card__add');
        if (!btn || btn.disabled) return;
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = i18n.adding || '...';
        try {
          await addToCart(parseInt(variantId), 1);
          const cart = await fetchCart();
          renderCart(cart);
          showToast(i18n.added + ' 🛒');
        } catch (err) {
          showToast(i18n.errorAdd + ': ' + err.message);
          btn.disabled = false;
          btn.textContent = i18n.addToCart || 'Toevoegen';
        }
      });
    }

    // Kortingscode toggle
    const discountToggle = $('cf-discount-toggle');
    const discountField  = $('cf-discount-field');
    if (discountToggle && discountField) {
      discountToggle.addEventListener('click', () => {
        const isOpen = discountField.style.display !== 'none';
        discountField.style.display = isOpen ? 'none' : 'block';
        discountToggle.setAttribute('aria-expanded', String(!isOpen));
        if (!isOpen) $('cf-discount-input') && $('cf-discount-input').focus();
      });
    }

    // Kortingscode toepassen
    const applyBtn = $('cf-discount-apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', handleDiscountApply);
    }
    const discountInput = $('cf-discount-input');
    if (discountInput) {
      discountInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') handleDiscountApply();
      });
    }

    // Kortingscode verwijderen (event delegation)
    const activeCodesEl = $('cf-discount-active-codes');
    if (activeCodesEl) {
      activeCodesEl.addEventListener('click', async (e) => {
        const btn = e.target.closest('.cf-discount__remove-code');
        if (!btn) return;
        await applyDiscount('');
        const cart = await fetchCart();
        renderCart(cart);
        showToast(i18n.discountRemoved);
      });
    }

    // Intercept Shopify add-to-cart forms (productpagina's)
    document.addEventListener('submit', handleFormSubmit);

    // Minimog custom event: cart:open
    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cf:cart:open', openDrawer);
  }

  async function handleItemAction(e) {
    const minusBtn  = e.target.closest('.cf-qty-minus');
    const plusBtn   = e.target.closest('.cf-qty-plus');
    const removeBtn = e.target.closest('.cf-cart-item__remove');

    if (!minusBtn && !plusBtn && !removeBtn) return;

    const key  = (minusBtn || plusBtn || removeBtn).dataset.key;
    const item = _cart && _cart.items.find(i => i.key === key);
    if (!item) return;

    const itemEl = e.target.closest('.cf-cart-item');
    if (itemEl) itemEl.classList.add('cf-cart-item--loading');

    let newQty;
    if (removeBtn) {
      newQty = 0;
    } else if (minusBtn) {
      newQty = item.quantity - 1;
    } else {
      newQty = item.quantity + 1;
    }

    // Debounce per item
    clearTimeout(_qtyDebounce[key]);
    _qtyDebounce[key] = setTimeout(async () => {
      try {
        await changeCartItem(key, newQty);
        const cart = await fetchCart();
        renderCart(cart);
      } catch (err) {
        showToast(err && err.stockFout && i18n.errorStock ? i18n.errorStock : i18n.errorQty);
        if (itemEl) itemEl.classList.remove('cf-cart-item--loading');
      }
    }, 300);
  }

  async function handleDiscountApply() {
    const input    = $('cf-discount-input');
    const feedback = $('cf-discount-feedback');
    if (!input || !feedback) return;

    const code = input.value.trim().toUpperCase();
    if (!code) return;

    const applyBtn = $('cf-discount-apply');
    if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = i18n.adding || '...'; }

    try {
      const cart = await applyDiscount(code);
      _cart = cart;

      // Controleer of code geldig is
      const applied = (cart.discount_codes || []).find(dc => dc.code.toUpperCase() === code);

      feedback.style.display = 'block';
      if (applied && applied.applicable) {
        feedback.className = 'cf-discount__feedback cf-feedback--success';
        feedback.textContent = unescapeStrong(i18n.discountApplied || 'Kortingscode "{{code}}" toegepast!').replace('{{code}}', code);
        input.value = '';
      } else {
        feedback.className = 'cf-discount__feedback cf-feedback--error';
        feedback.textContent = unescapeStrong(i18n.discountInvalid || 'Kortingscode "{{code}}" is niet geldig.').replace('{{code}}', code);
      }

      renderCart(cart);
    } catch (err) {
      feedback.style.display = 'block';
      feedback.className = 'cf-discount__feedback cf-feedback--error';
      feedback.textContent = i18n.errorGeneral || 'Er ging iets mis. Probeer het opnieuw.';
    } finally {
      if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = i18n.applying || 'Toepassen'; }
    }
  }

  async function handleFormSubmit(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; }

    try {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const qty       = parseInt(formData.get('quantity') || '1');
      const props     = {};
      formData.forEach((val, key) => {
        if (key.startsWith('properties[')) {
          const propKey = key.replace('properties[', '').replace(']', '');
          props[propKey] = val;
        }
      });

      await addToCart(variantId, qty, props);
      await openDrawer();
    } catch (err) {
      showToast('Kon product niet toevoegen: ' + err.message);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  // ─── CADEAU BIJ 50 EURO: ANTI-SNURK KIT OF DUO NASAL INHALER ───────────
  //
  // Regel 1 (bestaat als automatische korting "Gratis Anti-snurk kit vanaf 50 euro"):
  //   >= 50 euro aan de 11 snurkproducten  ->  gratis Anti-snurk kit
  // Regel 2 (tweede automatische korting, moet apart aangezet worden):
  //   >= 50 euro aan die 11 plus neusdouche/spoelzout  ->  gratis Duo Nasal Inhaler 2x
  //
  // De klant krijgt er altijd maar EEN. Zodra er een cadeau in de wagen ligt
  // verdwijnen alle "voeg toe"-knoppen en kan er alleen nog gewisseld worden.
  // Wisselen verwijdert eerst de oude regel en voegt daarna pas de nieuwe toe.

  var CF_CADEAU_DREMPEL = 5000;

  // ── Vertalingen cadeau-blok (de/en/fr/da/nl) ─────────────────────────
  // CONFIG.locale komt uit snippets/cf-cart-drawer.liquid ({{ request.locale.iso_code }}),
  // dus dit volgt automatisch de storefront-taal. Nieuwe taal? Vul een blok bij;
  // zonder match valt alles terug op Nederlands. Productnamen gelijk aan de
  // productpagina-banner (snippets/cf-kit-cadeau.liquid). {naam}/{waarde}/{tekort}/
  // {rest}/{uitleg} worden door cfFmt ingevuld; {waarde} bevat al ' <twv> <prijs>'.
  var CF_CADEAU_LOCALE = (CONFIG.locale || 'nl').toLowerCase().substring(0, 2);
  var CF_CADEAU_T_ALL = {
    nl: {
      naam:   { kit: 'Anti-snurk kit', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'anti-snurkproducten', inhaler: 'anti-snurk-, neusdouche- of spoelzoutproducten' },
      twv: 't.w.v.',
      bezig: 'Bezig...',
      tijdelijkUit: 'tijdelijk uitverkocht',
      kiesDe: 'Kies de {naam}',
      voegToe: 'Voeg mijn gratis {naam} toe',
      houdDe: 'Houd de {naam}',
      liever: 'Liever de {naam}? Wissel om',
      netUit: 'De {naam} is net uitverkocht. Kies het andere cadeau of probeer het later nog eens.',
      toevoegenMislukt: 'Toevoegen lukte niet. Ververs de pagina en probeer het opnieuw.',
      maarEen: 'Je kunt maar <strong>één</strong> cadeau kiezen. Welke wil je houden?',
      gratisToegevoegd: 'Gratis {naam} toegevoegd',
      nogNietGratis: 'Je <strong>{naam}</strong> is nog niet gratis. Nog <strong>&euro;{tekort}</strong> aan {uitleg} nodig.',
      cadeausOp: 'Je hebt een gratis cadeau verdiend, maar onze cadeaus zijn nu even op. We vullen snel aan.',
      gefeliciteerdKies: '<strong>Gefeliciteerd!</strong> Je hebt een gratis cadeau verdiend{waarde}. Kies er een:',
      anderUit: 'Het andere cadeau is nu uitverkocht.',
      gefeliciteerdEen: '<strong>Gefeliciteerd!</strong> Je hebt de gratis {naam}{waarde} verdiend.',
      nogTot: 'Nog <strong>&euro;{rest}</strong> tot een gratis cadeau{waarde}'
    },
    de: {
      naam:   { kit: 'Anti-Schnarch-Set', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'Anti-Schnarch-Produkten', inhaler: 'Anti-Schnarch-, Nasendusche- oder Spülsalz-Produkten' },
      twv: 'im Wert von',
      bezig: 'Wird geladen...',
      tijdelijkUit: 'zurzeit ausverkauft',
      kiesDe: '{naam} wählen',
      voegToe: 'Mein gratis {naam} hinzufügen',
      houdDe: '{naam} behalten',
      liever: 'Lieber {naam}? Jetzt wechseln',
      netUit: '{naam} ist gerade ausverkauft. Wähle das andere Geschenk oder versuche es später noch einmal.',
      toevoegenMislukt: 'Hinzufügen fehlgeschlagen. Lade die Seite neu und versuche es erneut.',
      maarEen: 'Du kannst nur <strong>ein</strong> Geschenk wählen. Welches möchtest du behalten?',
      gratisToegevoegd: 'Gratis {naam} hinzugefügt',
      nogNietGratis: 'Dein <strong>{naam}</strong> ist noch nicht gratis. Noch <strong>&euro;{tekort}</strong> an {uitleg} nötig.',
      cadeausOp: 'Du hast ein gratis Geschenk verdient, aber unsere Geschenke sind gerade aus. Wir füllen bald nach.',
      gefeliciteerdKies: '<strong>Glückwunsch!</strong> Du hast ein gratis Geschenk verdient{waarde}. Wähle eines aus:',
      anderUit: 'Das andere Geschenk ist zurzeit ausverkauft.',
      gefeliciteerdEen: '<strong>Glückwunsch!</strong> Du hast dein gratis {naam}{waarde} verdient.',
      nogTot: 'Noch <strong>&euro;{rest}</strong> bis zum gratis Geschenk{waarde}'
    },
    en: {
      naam:   { kit: 'Anti-Snoring Kit', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'anti-snoring products', inhaler: 'anti-snoring, nasal rinse or rinsing-salt products' },
      twv: 'worth',
      bezig: 'Working...',
      tijdelijkUit: 'temporarily sold out',
      kiesDe: 'Choose the {naam}',
      voegToe: 'Add my free {naam}',
      houdDe: 'Keep the {naam}',
      liever: 'Prefer the {naam}? Switch',
      netUit: 'The {naam} just sold out. Choose the other gift or try again later.',
      toevoegenMislukt: 'Could not add it. Refresh the page and try again.',
      maarEen: 'You can choose only <strong>one</strong> gift. Which would you like to keep?',
      gratisToegevoegd: 'Free {naam} added',
      nogNietGratis: 'Your <strong>{naam}</strong> isn\'t free yet. Add <strong>&euro;{tekort}</strong> more in {uitleg}.',
      cadeausOp: 'You\'ve earned a free gift, but our gifts are momentarily out of stock. We\'ll restock soon.',
      gefeliciteerdKies: '<strong>Congratulations!</strong> You\'ve earned a free gift{waarde}. Choose one:',
      anderUit: 'The other gift is currently sold out.',
      gefeliciteerdEen: '<strong>Congratulations!</strong> You\'ve earned the free {naam}{waarde}.',
      nogTot: '<strong>&euro;{rest}</strong> more for a free gift{waarde}'
    },
    fr: {
      naam:   { kit: 'Kit anti-ronflement', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'produits anti-ronflement', inhaler: 'produits anti-ronflement, de douche nasale ou de sel de rinçage' },
      twv: 'd\'une valeur de',
      bezig: 'En cours...',
      tijdelijkUit: 'temporairement épuisé',
      kiesDe: 'Choisir le {naam}',
      voegToe: 'Ajouter mon {naam} offert',
      houdDe: 'Garder le {naam}',
      liever: 'Vous préférez le {naam} ? Changer',
      netUit: 'Le {naam} vient de s\'épuiser. Choisissez l\'autre cadeau ou réessayez plus tard.',
      toevoegenMislukt: 'L\'ajout a échoué. Actualisez la page et réessayez.',
      maarEen: 'Vous ne pouvez choisir qu\'<strong>un</strong> cadeau. Lequel souhaitez-vous garder ?',
      gratisToegevoegd: '{naam} offert ajouté',
      nogNietGratis: 'Votre <strong>{naam}</strong> n\'est pas encore offert. Encore <strong>&euro;{tekort}</strong> en {uitleg}.',
      cadeausOp: 'Vous avez gagné un cadeau gratuit, mais nos cadeaux sont momentanément épuisés. Réapprovisionnement bientôt.',
      gefeliciteerdKies: '<strong>Félicitations !</strong> Vous avez gagné un cadeau gratuit{waarde}. Choisissez-en un :',
      anderUit: 'L\'autre cadeau est actuellement épuisé.',
      gefeliciteerdEen: '<strong>Félicitations !</strong> Vous avez gagné le {naam} gratuit{waarde}.',
      nogTot: 'Encore <strong>&euro;{rest}</strong> pour un cadeau gratuit{waarde}'
    },
    da: {
      naam:   { kit: 'anti-snorke-sæt', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'anti-snorke-produkter', inhaler: 'anti-snorke-, næseskyl- eller skyllesaltprodukter' },
      twv: 'til en værdi af',
      bezig: 'Arbejder...',
      tijdelijkUit: 'midlertidigt udsolgt',
      kiesDe: 'Vælg {naam}',
      voegToe: 'Tilføj gratis {naam}',
      houdDe: 'Behold {naam}',
      liever: 'Vil du hellere have {naam}? Skift',
      netUit: '{naam} er lige udsolgt. Vælg den anden gave, eller prøv igen senere.',
      toevoegenMislukt: 'Tilføjelsen mislykkedes. Genindlæs siden, og prøv igen.',
      maarEen: 'Du kan kun vælge <strong>én</strong> gave. Hvilken vil du beholde?',
      gratisToegevoegd: 'Gratis {naam} tilføjet',
      nogNietGratis: '<strong>{naam}</strong> er endnu ikke gratis. Der mangler <strong>&euro;{tekort}</strong> i {uitleg}.',
      cadeausOp: 'Du har optjent en gratis gave, men vores gaver er lige nu udsolgt. Vi fylder snart op.',
      gefeliciteerdKies: '<strong>Tillykke!</strong> Du har optjent en gratis gave{waarde}. Vælg en:',
      anderUit: 'Den anden gave er i øjeblikket udsolgt.',
      gefeliciteerdEen: '<strong>Tillykke!</strong> Du har optjent {naam} gratis{waarde}.',
      nogTot: 'Kun <strong>&euro;{rest}</strong> til en gratis gave{waarde}'
    }
  };
  var CFT = CF_CADEAU_T_ALL[CF_CADEAU_LOCALE] || CF_CADEAU_T_ALL.nl;
  function cfFmt(tmpl, vars) {
    return String(tmpl).replace(/\{(\w+)\}/g, function (m, k) {
      return (vars && vars[k] != null) ? vars[k] : '';
    });
  }
  function cfNaam(cadeau)   { return (CFT.naam && CFT.naam[cadeau.key]) || cadeau.naam; }
  function cfUitleg(cadeau) { return (CFT.uitleg && CFT.uitleg[cadeau.key]) || cadeau.uitleg; }

  // De 11 producten van de bestaande kit-korting
  var CF_SNURK_IDS = (window.cfCadeauIds && window.cfCadeauIds.snurk && window.cfCadeauIds.snurk.length)
    ? window.cfCadeauIds.snurk
    : [8216809210167, 8216826741047, 10092585025870, 10387535626574,
       10387551617358, 10387639828814, 10387664142670, 10440974991694, 10623650169166,
       10624140214606, 15837342630222];

  // Neusdouche en spoelzout, tellen alleen mee voor de inhaler
  var CF_SPOEL_IDS = (window.cfCadeauIds && window.cfCadeauIds.inhaler && window.cfCadeauIds.inhaler.length)
    ? window.cfCadeauIds.inhaler
    : [8764440019278, 10622441423182, 15934078976334, 10824854405454];

  var CF_CADEAUS = [
    {
      key: 'kit',
      variant: 44952024154423,
      naam: 'Anti-snurk kit',
      telt: CF_SNURK_IDS,
      uitleg: 'anti-snurkproducten'
    },
    {
      key: 'inhaler',
      variant: 59189325365582,
      naam: 'Duo Nasal Inhaler 2x',
      telt: CF_SNURK_IDS.concat(CF_SPOEL_IDS),
      uitleg: 'anti-snurk-, neusdouche- of spoelzoutproducten'
    }
  ];

  // Variants die tijdens deze sessie uitverkocht bleken (add.js gaf een fout)
  var cfCadeauUit = {};
  var cfCadeauEl = null;
  var cfCadeauLaatsteRegels = [];
  var cfCadeauFoutTekst = '';

  function cfCadeauBedrag(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  // Voorraad en prijs komen uit snippets/cf-cart-drawer.liquid, die ze
  // rechtstreeks uit het product leest. Nergens een prijs vastzetten.
  function cfCadeauInfo(cadeau) {
    var lijst = window.cfCadeauInfo;
    return (lijst && lijst[cadeau.variant]) || null;
  }

  function cfCadeauOpVoorraad(cadeau) {
    if (cfCadeauUit[cadeau.variant]) return false;
    var info = cfCadeauInfo(cadeau);
    if (!info || typeof info.op === 'undefined') return true; // onbekend: laat de knop staan, add.js vangt het af
    return info.op > 0;
  }

  // " t.w.v. EUR 12,99", of leeg als de prijs onbekend is
  function cfCadeauWaarde(cadeau) {
    var info = cfCadeauInfo(cadeau);
    return info && info.prijs ? ' ' + CFT.twv + ' ' + info.prijs : '';
  }

  // Waarde die voor beide cadeaus geldt, of leeg als ze verschillen
  function cfCadeauWaardeSamen(lijst) {
    var eerste = cfCadeauWaarde(lijst[0]);
    for (var i = 1; i < lijst.length; i++) {
      if (cfCadeauWaarde(lijst[i]) !== eerste) return '';
    }
    return eerste;
  }

  function cfCadeauIsCadeauregel(item) {
    for (var i = 0; i < CF_CADEAUS.length; i++) {
      if (item.variant_id === CF_CADEAUS[i].variant) return true;
    }
    return false;
  }

  // Staffelpercentage op het aantal betaalde (niet-cadeau) artikelen. Gelijk aan
  // de checkout-Function, zodat thema en afrekenen exact hetzelfde beslissen.
  function cfStaffelPct(items) {
    var qty = 0;
    for (var i = 0; i < items.length; i++) {
      if (!cfCadeauIsCadeauregel(items[i])) qty += items[i].quantity;
    }
    var pct = 0;
    for (var t = 0; t < REWARD_TIERS.length; t++) {
      if (qty >= REWARD_TIERS[t].minItems) pct = REWARD_TIERS[t].discount;
    }
    return pct;
  }

  function cfCadeauSom(cadeau, items) {
    // Bedrag van de kwalificerende producten NA de staffelkorting (in centen).
    // De cadeaudrempel geldt op wat de klant werkelijk betaalt, net als de Function.
    var som = items.reduce(function (s, item) {
      if (cfCadeauIsCadeauregel(item)) return s; // het cadeau telt niet mee voor zijn eigen drempel
      return cadeau.telt.indexOf(item.product_id) > -1 ? s + item.original_line_price : s;
    }, 0);
    var pct = cfStaffelPct(items);
    return Math.round(som * (1 - pct / 100));
  }

  function cfCadeauZoek(key) {
    for (var i = 0; i < CF_CADEAUS.length; i++) {
      if (CF_CADEAUS[i].key === key) return CF_CADEAUS[i];
    }
    return null;
  }

  function cfCadeauKnopHtml(cadeau, klaar) {
    if (!cfCadeauOpVoorraad(cadeau)) {
      return '<button type="button" disabled>' + cfNaam(cadeau) + ' &middot; ' + CFT.tijdelijkUit + '</button>';
    }
    return '<button type="button" data-cadeau-add="' + cadeau.key + '">' +
      (klaar || cfFmt(CFT.kiesDe, { naam: cfNaam(cadeau) })) + '</button>';
  }

  // Houdt een cadeau over en ruimt alle andere cadeauregels op.
  // In een keer via /cart/update.js: los per regel wijzigen laat Shopify de
  // overige regelsleutels opnieuw uitdelen en dan mist de tweede wijziging.
  function cfCadeauHoud(knop, cadeauRegels) {
    var houd = knop.getAttribute('data-cadeau-houd');
    knop.disabled = true;
    knop.innerHTML = CFT.bezig;
    var updates = {};
    var alGehouden = false;
    cadeauRegels.forEach(function (c) {
      var naar = 0;
      if (c.cadeau.key === houd && !alGehouden) { naar = 1; alGehouden = true; }
      updates[c.regel.key] = naar;
    });
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      return fetchCart().then(function (nieuweCart) { renderCart(nieuweCart); });
    }).catch(function () {
      fetchCart().then(renderCart).catch(function () {});
    });
  }

  function cfCadeauActie(knop) {
    var cadeau = cfCadeauZoek(knop.getAttribute('data-cadeau-add') || knop.getAttribute('data-cadeau-wissel'));
    if (!cadeau) return;
    var wisselKey = knop.getAttribute('data-cadeau-verwijder');
    var oud = knop.innerHTML;
    knop.disabled = true;
    knop.innerHTML = CFT.bezig;
    cfCadeauFoutTekst = '';

    var stap = wisselKey
      ? fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: wisselKey, quantity: 0 })
        })
      : Promise.resolve(null);

    stap.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: cadeau.variant, quantity: 1 }] })
      });
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          var fout = new Error('add mislukt');
          fout.shopify = data;
          throw fout;
        });
      }
      return null;
    }).then(function () {
      return fetchCart().then(function (nieuweCart) {
        renderCart(nieuweCart);
        openDrawer();
      });
    }).catch(function (fout) {
      // Meestal: cadeau net uitverkocht. Zet hem op uit zodat de knop niet
      // opnieuw stilletjes faalt, en vertel de klant wat er aan de hand is.
      cfCadeauUit[cadeau.variant] = true;
      var melding = fout && fout.shopify && fout.shopify.description;
      cfCadeauFoutTekst = melding
        ? cfFmt(CFT.netUit, { naam: cfNaam(cadeau) })
        : CFT.toevoegenMislukt;
      knop.disabled = false;
      knop.innerHTML = oud;
      fetchCart().then(renderCart).catch(function () {});
    });
  }

  function renderKitCadeau(cart, itemsEl) {
    var el = document.getElementById('cfKitCadeau');
    if (!el) {
      if (!itemsEl || !itemsEl.parentNode) return;
      el = document.createElement('div');
      el.id = 'cfKitCadeau';
      itemsEl.parentNode.insertBefore(el, itemsEl);
      var stijl = document.createElement('style');
      stijl.textContent = '#cfKitCadeau{margin:0 0 10px;font-size:13px;line-height:1.5;color:#003d63}' +
        '#cfKitCadeau .cfkit{padding:9px 12px;border-radius:8px;background:rgba(232,112,58,0.10)}' +
        '#cfKitCadeau .cfkit--klaar{background:rgba(46,160,67,0.12);color:#1f7a33;font-weight:600}' +
        '#cfKitCadeau .cfkit--let-op{background:rgba(214,145,20,0.14);color:#8a5a00}' +
        '#cfKitCadeau .cfkit__keuze{display:flex;flex-direction:column;gap:6px;margin-top:8px}' +
        '#cfKitCadeau button{padding:8px 14px;border:0;border-radius:8px;background:#E8703A;color:#fff;font-weight:700;font-size:13px;cursor:pointer;width:100%}' +
        '#cfKitCadeau button[disabled]{opacity:.5;cursor:not-allowed}' +
        '#cfKitCadeau .cfkit__wissel{margin-top:6px;background:transparent;color:#003d63;border:1px solid rgba(0,61,99,.35);font-weight:600}' +
        '#cfKitCadeau .cfkit__fout{margin:6px 0 0;color:#b3261e;font-weight:600}' +
        '#cfKitCadeau .cfkit__op{margin:6px 0 0;opacity:.75}';
      document.head.appendChild(stijl);
      el.addEventListener('click', function (e) {
        var knop = e.target.closest('[data-cadeau-add],[data-cadeau-wissel],[data-cadeau-houd]');
        if (!knop || knop.disabled) return;
        if (knop.hasAttribute('data-cadeau-houd')) {
          cfCadeauHoud(knop, cfCadeauLaatsteRegels);
        } else {
          cfCadeauActie(knop);
        }
      });
    }
    cfCadeauEl = el;

    var items = (cart && cart.items) || [];

    // Alle cadeauregels in de wagen (normaal precies nul of een)
    var cadeauRegels = [];
    for (var i = 0; i < items.length; i++) {
      for (var j = 0; j < CF_CADEAUS.length; j++) {
        if (items[i].variant_id === CF_CADEAUS[j].variant) {
          cadeauRegels.push({ cadeau: CF_CADEAUS[j], regel: items[i] });
        }
      }
    }
    var inWagen = cadeauRegels.length ? cadeauRegels[0] : null;
    cfCadeauLaatsteRegels = cadeauRegels;

    var kit = CF_CADEAUS[0];
    var inh = CF_CADEAUS[1];
    var somKit = cfCadeauSom(kit, items);
    var somInh = cfCadeauSom(inh, items);
    var haalt = {};
    haalt[kit.key] = somKit >= CF_CADEAU_DREMPEL;
    haalt[inh.key] = somInh >= CF_CADEAU_DREMPEL;

    // Niets relevants in de wagen en geen cadeau: helemaal niets tonen
    if (!inWagen && somInh === 0) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;

    var fout = cfCadeauFoutTekst ? '<p class="cfkit__fout">' + cfCadeauFoutTekst + '</p>' : '';

    // ── Vangnet: meer dan een cadeau, of meer dan een stuks ──────────────
    // Kan gebeuren als iemand een cadeau rechtstreeks via de productpagina
    // toevoegt. Met twee actieve kortingsregels zouden ze allebei kunnen slaan.
    var cadeauStuks = cadeauRegels.reduce(function (n, c) { return n + c.regel.quantity; }, 0);
    var teVeel = cadeauStuks > 1;
    if (teVeel) {
      var gezien = {};
      var houdKnoppen = cadeauRegels.filter(function (c) {
        if (gezien[c.cadeau.key]) return false;
        gezien[c.cadeau.key] = true;
        return true;
      }).map(function (c) {
        return '<button type="button" data-cadeau-houd="' + c.cadeau.key + '">' + cfFmt(CFT.houdDe, { naam: cfNaam(c.cadeau) }) + '</button>';
      }).join('');
      el.innerHTML = '<div class="cfkit cfkit--let-op">&#9888; ' + CFT.maarEen +
        '<div class="cfkit__keuze">' + houdKnoppen + '</div></div>' + fout;
      return;
    }

    // ── Er ligt al een cadeau in de wagen ────────────────────────────────
    if (inWagen) {
      cfCadeauFoutTekst = ''; // er ligt een cadeau in de wagen, oude foutmelding is niet meer relevant
      fout = '';
      var dit = inWagen.cadeau;
      var ander = dit === kit ? inh : kit;
      var mag = haalt[dit.key];
      var anderMag = haalt[ander.key] && cfCadeauOpVoorraad(ander);
      var wisselKnop = anderMag
        ? '<button type="button" class="cfkit__wissel" data-cadeau-wissel="' + ander.key +
          '" data-cadeau-verwijder="' + inWagen.regel.key + '">' + cfFmt(CFT.liever, { naam: cfNaam(ander) }) + '</button>'
        : '';

      if (mag) {
        el.innerHTML = '<div class="cfkit cfkit--klaar">&#10003; ' +
          cfFmt(CFT.gratisToegevoegd, { naam: cfNaam(dit) }) + wisselKnop + '</div>' + fout;
      } else {
        var tekort = cfCadeauBedrag(CF_CADEAU_DREMPEL - cfCadeauSom(dit, items));
        el.innerHTML = '<div class="cfkit cfkit--let-op">&#9888; ' +
          cfFmt(CFT.nogNietGratis, { naam: cfNaam(dit), tekort: tekort, uitleg: cfUitleg(dit) }) +
          wisselKnop + '</div>' + fout;
      }
      return;
    }

    // ── Nog geen cadeau in de wagen ──────────────────────────────────────
    var keuze = CF_CADEAUS.filter(function (c) { return haalt[c.key]; });
    var leverbaar = keuze.filter(cfCadeauOpVoorraad);

    if (keuze.length && !leverbaar.length) {
      el.innerHTML = '<div class="cfkit">&#127873; ' + CFT.cadeausOp + '</div>' + fout;
      return;
    }

    if (leverbaar.length > 1) {
      el.innerHTML = '<div class="cfkit">&#127873; ' +
        cfFmt(CFT.gefeliciteerdKies, { waarde: cfCadeauWaardeSamen(leverbaar) }) +
        '<div class="cfkit__keuze">' + leverbaar.map(function (c) { return cfCadeauKnopHtml(c); }).join('') + '</div>' +
        '</div>' + fout;
      return;
    }

    if (leverbaar.length === 1) {
      var enige = leverbaar[0];
      var opTekst = keuze.length > 1
        ? '<p class="cfkit__op">' + CFT.anderUit + '</p>'
        : '';
      el.innerHTML = '<div class="cfkit">&#127873; ' +
        cfFmt(CFT.gefeliciteerdEen, { naam: cfNaam(enige), waarde: cfCadeauWaarde(enige) }) + opTekst +
        '<div class="cfkit__keuze">' + cfCadeauKnopHtml(enige, cfFmt(CFT.voegToe, { naam: cfNaam(enige) })) + '</div>' +
        '</div>' + fout;
      return;
    }

    // Nog onder de drempel. De inhalerlijst is de ruimste, dus die bepaalt
    // hoeveel er nog bij moet voor minimaal een cadeau.
    var rest = cfCadeauBedrag(CF_CADEAU_DREMPEL - somInh);
    el.innerHTML = '<div class="cfkit">&#127873; ' +
      cfFmt(CFT.nogTot, { rest: rest, waarde: cfCadeauWaardeSamen(CF_CADEAUS) }) + '</div>' + fout;
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────

  function init() {
    if (!drawer) return;
    initEvents();
    // Initieel cart count laden
    fetchCart().then(cart => {
      const countEl = $('cf-cart-count');
      if (countEl) countEl.textContent = cart.item_count || 0;
      document.querySelectorAll('[data-cart-count], #cfm-cart-count').forEach(el => {
        el.textContent = cart.item_count || 0;
      });
    }).catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Publieke API
  window.cfCart = { open: openDrawer, close: closeDrawer, refresh: fetchCart };

})();
